import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonLabel, IonFab, IonFabButton, IonIcon, IonSearchbar } from '@ionic/react';
import { useState, useEffect } from 'react';
import './Clients.css';

import { personAddOutline } from 'ionicons/icons';
import { useHistory } from 'react-router';
import { addClientListener } from '../firebase/clients';
import { getUser } from '../firebase/users';
import { getCurrentUserUID } from '../firebase/firebase';
import e from 'express';
import { getUserIdFromPath } from '../firebase/firebaseStorage';
import { getPermissionsDisplay } from './Permissions';


const Clients: React.FC = () => {
  const history = useHistory();
  const [clients, setClients] = useState([]);
  const [initData, setInitData] = useState({});
  const [filtr, setFiltr] = useState("");

  useEffect(() => {
    addClientListener((list: any) => {
      setClients(list);
    });
  }, []);


  const handleChange = (value: any) => {
    if (value !== filtr) {
      setFiltr(value)
    }
  }

  function checkFiltr(p: any) {
    //console.log("Clients-checkFiltr", p)
    if (filtr === "") {
      return true;
    }
    if ((p.surname + " " + p.name).toLowerCase().indexOf(filtr.toLowerCase()) > -1) {
      return true;
    }
    if ((p.gsurname + " " + p.gname).toLowerCase().indexOf(filtr.toLowerCase()) > -1) {
      return true;
    }
    if ((p.phone).toLowerCase().indexOf(filtr.toLowerCase()) > -1) {
      return true;
    }
    if ((p.gphone).toLowerCase().indexOf(filtr.toLowerCase()) > -1) {
      return true;
    }
    return false;
  }

  return (
    <IonPage >
      <IonHeader>
        <IonToolbar>
          <IonTitle slot="start">Klienci</IonTitle>
          <IonSearchbar placeholder="" value={filtr} onIonChange={(e) => handleChange(e.detail.value)}></IonSearchbar>
        </IonToolbar>

      </IonHeader>
      <IonContent fullscreen>


      {clients.map((p: any) => (
          <div>
            {checkFiltr(p) ? <IonItem routerLink={"/app/clients/" + p.id} key={p.id} >
              {getPermissionsDisplay(p)}<IonLabel>{p.surname + " " + p.name}</IonLabel>
            </IonItem> : ""}
          </div>
        ))}

        {/* { <table>
        {clients.map((p: any) => (
          (p.phone.trim().length>8 ||  p.gphone.trim().length>8 ? 
          <tr>
            <td>{p.surname + " " + p.name}</td>
            <td>{(p.phone.length==9?"48":"")+ p.phone}</td>
            <td>{(p.gphone.length==9?"48":"")+ p.gphone}</td>
          </tr>
          : '')
        ))
        }
        </table> } */}

        <IonFab vertical="bottom" horizontal="end" slot="fixed">
          <IonFabButton onClick={() => { history.push("/app/clients/0") }}>
            <IonIcon icon={personAddOutline}></IonIcon>
          </IonFabButton>
        </IonFab>
      </IonContent>
    </IonPage>
  );
};

export default Clients;
